"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _utils = require("../utils/utils");

var _default = {
  title: 'Playing Options',
  description: "Choose when video items will start playing: On hover, on click or autoplay",
  isRelevant: function isRelevant(styleParams) {
    return true;
  },
  options: (0, _utils.createOptions)('videoPlay'),
  type: _constants.INPUT_TYPES.OPTIONS,
  "default": _constants.GALLERY_CONSTS.videoPlay.HOVER
};
exports["default"] = _default;